import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import api, { formatApiError } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import Logo from '@/components/Logo';
import Footer from '@/components/Footer';

export default function ForgotPassword() {
	const [email, setEmail] = useState('');
	const [submitting, setSubmitting] = useState(false);
	const [devToken, setDevToken] = useState(null);

	const submit = async (e) => {
		e.preventDefault();
		setSubmitting(true);
		try {
			const { data } = await api.post('/auth/forgot-password', { email: email.trim() });
			if (data?.dev_reset_token) {
				setDevToken(data.dev_reset_token);
				toast.success('Reset link issued (dev mode shown below).');
			} else {
				toast.success('If an account exists, a reset email is on its way.');
			}
		} catch (err) {
			toast.error(formatApiError(err));
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div className="min-h-screen flex items-center justify-center mesh-bg px-4 py-10">
			<div className="w-full max-w-md card-soft p-8">
				<Logo />
				<h2 className="mt-6 text-3xl font-heading font-bold tracking-tight text-slate-900">Forgot password</h2>
				<p className="mt-2 text-slate-600">We&apos;ll email you a secure reset link.</p>
				<form onSubmit={submit} className="mt-8 space-y-4">
					<Label htmlFor="email">Email</Label>
					<Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" />
					<Button type="submit" disabled={submitting} className="w-full h-12 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white font-semibold" data-testid="forgot-submit-button">
						{submitting ? 'Sending…' : 'Send reset link'}
					</Button>
				</form>
				{devToken && (
					<div className="mt-6 p-4 rounded-2xl bg-amber-50 border border-amber-200 text-amber-900 text-sm">
						<div className="font-semibold mb-1">Dev mode: reset link</div>
						<Link to={`/reset-password?token=${devToken}`} className="break-all underline">
							{`${window.location.origin}/reset-password?token=${devToken}`}
						</Link>
					</div>
				)}
				<p className="mt-6 text-sm text-center">
					<Link to="/login" className="font-semibold text-emerald-700 hover:underline">Back to sign in</Link>
				</p>
			</div>
			<Footer compact className="mt-8" />
		</div>
	);
}
